var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{style:(_vm.height ? {overflow:'auto',height:_vm.height} :{overflow:'auto'}),attrs:{"id":"myIframe","width":"100%","height":"100%","frameborder":"0","src":_vm.url},on:{"load":_vm.myIframeload}})}
var staticRenderFns = []

export { render, staticRenderFns }